module.exports = __webpack_public_path__ + "static/media/FeeBalanceApplicantPortal.95fd3bfc.svg";